// extracted by mini-css-extract-plugin
export default {"TitleDialogContent":"ModalGlobal_TitleDialogContent__zh-W3","TitleDialogTexto":"ModalGlobal_TitleDialogTexto__fYB5d"};